import * as angular from 'angular';

export class CheckboxToggleController {
  private checked: boolean;
}

export const CheckboxToggle: angular.IComponentOptions = {
  controller: CheckboxToggleController,
  controllerAs: 'ctrl',
  bindings: {
    checked: '<',
  },
  template: `
    <span class="form-toggle checkbox-lg">
      <input
        type="checkbox"
        ng-checked="ctrl.checked"
      />

      <label>
        <span class="toggle">
          <i class="icon-success-check-inverted checkmark"></i>
          <span class="switch"></span>
        </span>
      </label>
    </span>
  `,
};
